@if (user?.isInternal) {
  <div class="grid-x">
    <div class="cell large-1 medium-1 small-1 red bold">
      @if (firstNoteBrief != noNoteText) {
        IMPORTANT:
      }
    </div>
    <div class="cell large-6 medium-6 small-6 text-align-center" [innerHtml]="firstNoteBrief" [ngClass]="{ 'red': firstNoteBrief != noNoteText }">
    </div>
    <div class="cell large-2 medium-2 small-2 text-align-center">
      @if (firstCriticalNote != null) {
        <button class="button" (click)="viewNotes()">View</button>
      }
    </div>
    <div class="cell large-3 medium-3 small-3">
      <button class="button" (click)="addCriticalNote()">Add Critical Note</button>
    </div>
  </div>
}


<div class="dialogContainer" [ngClass]="{ 'visible': isDialogOpen }">
  <div class="dialog">
    <div class="grid-x">
      <div class="cell large-11 medium-11 small-11 bold text-align-center">
        Critical {{relation}} Notes
      </div>
      <div class="cell large-1 medium-1 small-1 text-align-right close-button margin-bottom" aria-label="Close">
        <button (click)="closeDialog()">&times;</button>
      </div>
      <div class="cell large-12 medium-12 small-12 margin-top-large" [ngClass]="{ 'editor-collapsed': currentMode !== modes.InputView }">
        <text-editor [froalaOptions]="froalaOptions" [required]="true" (formBuilt)="editorFormBuilt($event)"></text-editor>
      </div>
      @if (editorReady) {
        <div class="cell large-12 medium-12 small-12 text-align-center margin-top" [hidden]="currentMode !== modes.InputView">
          <span class="padding-right">
            <button class="button" (click)="cancelNote(true)" [disabled]="isSaving">Cancel and Close Editor</button>
          </span>
          <span class="padding-right">
            <button class="button" (click)="cancelNote(false)" [disabled]="isSaving || noteForm?.pristine">Cancel</button>
          </span>
          <span>
            <button class="button" (click)="saveNote()" [disabled]="isSaving || noteForm?.invalid">Save</button>
          </span>
        </div>
        <div class="cell large-12 medium-12 small-12" [hidden]="currentMode !== modes.InputView">
          <text-loader [runObservable]="savingObs$" [tickType]="'.'" [cycleLimit]="50" [text]="'Saving Note... please wait'"></text-loader>
        </div>
      }
      <div class="cell large-12 medium-12 small-12 text-align-right" [hidden]="currentMode !== modes.LongView">
        <button class="button" (click)="addCriticalNote()">Add Critical Note</button>
      </div>
      @for (note of notes; track note) {
        <div class="cell large-9 medium-9 small-9 padding-all margin-top margin-bottom critical-note" >
          <div class="note-group">
            <div class="notes no-margin">
              <div class="note-header default-font">
                <strong>{{note.createdBy}}</strong><span class="float-right">{{note.createdDate | date: 'M/d/yy | h:mma'}}</span>
              </div>
              <div [innerHTML]="note.text"></div>
            </div>
          </div>
        </div>
        <div class="cell large-3 medium-3 small-3 margin-top padding-left">
          <button class="button" (click)="demoteNote(note.id)">Change Note to Private</button><br />
          <button class="button" (click)="deleteNote(note.id)">Delete Note</button>
        </div>
      }
    </div>
  </div>
</div>
